import React, { useState } from 'react';
import {
  FaGift,
  FaTag,
  FaFire,
  FaShareAlt,
  FaWhatsapp,
  FaTelegram,
  FaEnvelope,
  FaCopy,
  FaCheckCircle,
  FaTimes,
  FaClock,
  FaArrowRight,
  FaStar,
  FaGem,
  FaCrown
} from 'react-icons/fa';

const SpecialOffers = () => {
  const [toast, setToast] = useState({ show: false, message: "", type: "" });
  const [copiedOffer, setCopiedOffer] = useState(null);
  const [shareLoading, setShareLoading] = useState(null);

  const showToast = (message, type = "success") => {
    setToast({ show: true, message, type });
    setTimeout(() => {
      setToast({ show: false, message: "", type: "" });
    }, 3000);
  };

  // Dummy Offers Data - Sab show hoga, expiry check nahi hai
  const offers = [
    {
      id: 1,
      title: "Summer Sale Blast!",
      description: "Get 50% off on all premium plans. Limited time offer!",
      code: "SUMMER50",
      discount: "50% OFF",
      validTill: "2025-12-31",
      icon: <FaFire className="text-orange-500" />,
      bgColor: "from-orange-500 to-red-500",
      tag: "HOT",
      coins: 500
    },
    {
      id: 2,
      title: "Referral Bonus",
      description: "Earn 100 coins for every friend who joins using your code",
      code: "REFER100",
      discount: "100 Coins",
      validTill: "2025-12-31",
      icon: <FaGift className="text-emerald-500" />,
      bgColor: "from-emerald-500 to-teal-500",
      tag: "BONUS",
      coins: 100
    },
    {
      id: 3,
      title: "Premium Plan Offer",
      description: "Upgrade to premium and get 30% discount + 500 bonus coins",
      code: "PREMIUM30",
      discount: "30% OFF",
      validTill: "2025-12-31",
      icon: <FaCrown className="text-yellow-500" />,
      bgColor: "from-purple-500 to-pink-500",
      tag: "PREMIUM",
      coins: 500
    },
    {
      id: 4,
      title: "Welcome Offer",
      description: "New users get 200 coins absolutely free on first signup",
      code: "WELCOME200",
      discount: "200 Coins",
      validTill: "2025-12-31",
      icon: <FaStar className="text-blue-500" />,
      bgColor: "from-blue-500 to-indigo-500",
      tag: "NEW",
      coins: 200
    },
    {
      id: 5,
      title: "Flash Sale",
      description: "Get 75% off on annual plans. Hurry up! Limited slots",
      code: "FLASH75",
      discount: "75% OFF",
      validTill: "2025-12-31",
      icon: <FaGem className="text-cyan-500" />,
      bgColor: "from-cyan-500 to-blue-500",
      tag: "FLASH",
      coins: 1000
    },
    {
      id: 6,
      title: "Festival Special",
      description: "Special festive discount of 40% on all plans + extra 100 coins",
      code: "FESTIVE40",
      discount: "40% OFF",
      validTill: "2025-12-31",
      icon: <FaGift className="text-pink-500" />,
      bgColor: "from-pink-500 to-rose-500",
      tag: "FESTIVE",
      coins: 100
    },
    {
      id: 7,
      title: "Diwali Dhamaka",
      description: "Get 60% off + 1000 bonus coins on annual subscription",
      code: "DIWALI60",
      discount: "60% OFF",
      validTill: "2025-12-31",
      icon: <FaFire className="text-orange-500" />,
      bgColor: "from-red-500 to-orange-500",
      tag: "FESTIVE",
      coins: 1000
    },
    {
      id: 8,
      title: "New Year Special",
      description: "Start new year with 45% discount on all plans",
      code: "NEWYEAR45",
      discount: "45% OFF",
      validTill: "2025-12-31",
      icon: <FaStar className="text-yellow-500" />,
      bgColor: "from-indigo-500 to-purple-500",
      tag: "SPECIAL",
      coins: 300
    },
    {
      id: 9,
      title: "Corporate Plan",
      description: "Special discount for corporate clients - 35% off + 500 coins",
      code: "CORP35",
      discount: "35% OFF",
      validTill: "2025-12-31",
      icon: <FaCrown className="text-blue-500" />,
      bgColor: "from-slate-500 to-gray-500",
      tag: "CORPORATE",
      coins: 500
    }
  ];

  const copyOfferCode = (code) => {
    navigator.clipboard.writeText(code);
    setCopiedOffer(code);
    showToast(`Offer code "${code}" copied!`, "success");
    setTimeout(() => setCopiedOffer(null), 3000);
  };

  const shareOffer = async (offer, platform) => {
    const text = `🎉 Special Offer: ${offer.title}\n\n${offer.description}\n\nUse Code: ${offer.code}\nGet ${offer.discount}\nValid till: ${offer.validTill}\n\nGrab this deal now!`;
    const url = `${window.location.origin}/specialoffers`;

    if (platform === 'whatsapp') {
      const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(text + '\n\n' + url)}`;
      window.open(whatsappUrl, '_blank');
    } else if (platform === 'telegram') {
      const telegramUrl = `https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`;
      window.open(telegramUrl, '_blank');
    } else if (platform === 'email') {
      const subject = `Special Offer: ${offer.title}`;
      const body = `${text}\n\nClick here to claim: ${url}`;
      const emailUrl = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
      window.open(emailUrl, '_blank');
    } else if (platform === 'native') {
      setShareLoading(offer.id);
      try {
        if (navigator.share) {
          await navigator.share({
            title: offer.title,
            text: text,
            url: url
          });
          showToast("Shared successfully!", "success");
        } else {
          copyOfferCode(offer.code);
        }
      } catch (err) {
        if (err.name !== 'AbortError') {
          showToast("Share failed", "error");
        }
      } finally {
        setShareLoading(null);
      }
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
  };

  return (
    <div className="p-4 md:p-6">
      {/* Custom Toast */}
      {toast.show && (
        <div className="fixed top-5 right-5 z-50 animate-in slide-in-from-top-2 duration-300">
          <div className={`flex items-center gap-2 px-4 py-2 rounded-lg shadow-lg ${
            toast.type === "success" ? "bg-emerald-500" : "bg-red-500"
          } text-white text-xs font-medium`}>
            {toast.type === "success" ? <FaCheckCircle /> : <FaTimes />}
            {toast.message}
          </div>
        </div>
      )}

      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-gradient-to-r from-orange-500 to-pink-500 rounded-2xl flex items-center justify-center mx-auto mb-3 shadow-lg">
            <FaTag className="text-white text-2xl" />
          </div>
          <h1 className="text-2xl font-bold text-gray-800">Special Offers</h1>
          <p className="text-xs text-gray-500 mt-1">Limited time deals & exclusive discounts</p>
        </div>

        {/* Offers Grid - Sab show hoga, koi filter nahi */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {offers.map((offer) => (
            <div
              key={offer.id}
              className="group bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
            >
              {/* Offer Header with Gradient */}
              <div className={`bg-gradient-to-r ${offer.bgColor} p-4 relative overflow-hidden`}>
                <div className="absolute top-0 right-0 w-20 h-20 bg-white/10 rounded-full -mr-10 -mt-10"></div>
                <div className="absolute bottom-0 left-0 w-16 h-16 bg-white/10 rounded-full -ml-8 -mb-8"></div>
                
                <div className="flex items-start justify-between relative z-10">
                  <div className="flex items-center gap-2">
                    <div className="w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center backdrop-blur">
                      {offer.icon}
                    </div>
                    <div>
                      <div className="flex items-center gap-2">
                        <span className="text-[8px] font-bold bg-white/20 px-2 py-0.5 rounded-full text-white uppercase">
                          {offer.tag}
                        </span>
                        <span className="text-[8px] text-white/80">
                          Valid till: {formatDate(offer.validTill)}
                        </span>
                      </div>
                      <h3 className="text-sm font-bold text-white mt-1">{offer.title}</h3>
                    </div>
                  </div>
                  <div className="text-right">
                    <div className="text-lg font-black text-white">{offer.discount}</div>
                    <div className="text-[8px] text-white/80">Save big!</div>
                  </div>
                </div>
              </div>

              {/* Offer Body */}
              <div className="p-4">
                <p className="text-xs text-gray-600 mb-3">{offer.description}</p>
                
                {/* Bonus Coins */}
                <div className="flex items-center gap-2 mb-3 p-2 bg-amber-50 rounded-lg border border-amber-100">
                  <FaGift className="text-amber-500 text-xs" />
                  <span className="text-[10px] font-medium text-amber-700">
                    Bonus: {offer.coins} coins on purchase
                  </span>
                </div>

                {/* Offer Code */}
                <div className="flex items-center justify-between gap-2 mb-3">
                  <div className="flex-1 bg-gray-50 rounded-lg px-3 py-2 border border-gray-200">
                    <p className="text-[9px] text-gray-400 uppercase tracking-wider">Offer Code</p>
                    <p className="text-xs font-mono font-bold text-gray-800">{offer.code}</p>
                  </div>
                  <button
                    onClick={() => copyOfferCode(offer.code)}
                    className="px-3 py-2 bg-blue-50 text-blue-600 rounded-lg hover:bg-blue-100 transition text-sm font-medium flex items-center gap-1"
                  >
                    {copiedOffer === offer.code ? <FaCheckCircle className="text-xs" /> : <FaCopy className="text-xs" />}
                    {copiedOffer === offer.code ? "Copied" : "Copy"}
                  </button>
                </div>

                {/* Validity Status - Always show active */}
                <div className="flex items-center justify-between mb-3">
                  <div className="flex items-center gap-1">
                    <FaClock className="text-gray-400 text-[10px]" />
                    <span className="text-[10px] font-medium text-emerald-600">
                      Active Offer
                    </span>
                  </div>
                  <span className="text-[8px] font-bold text-emerald-600 bg-emerald-100 px-2 py-0.5 rounded-full">
                    Limited Time!
                  </span>
                </div>

                {/* Action Buttons */}
                <div className="flex gap-2">
                  <button className="flex-1 px-3 py-2 bg-emerald-600 text-white rounded-lg text-xs font-medium hover:bg-emerald-700 transition flex items-center justify-center gap-1">
                    Claim Offer
                    <FaArrowRight className="text-[10px]" />
                  </button>
                  
                  <div className="relative group">
                    <button className="px-3 py-2 bg-gray-100 text-gray-600 rounded-lg hover:bg-gray-200 transition">
                      <FaShareAlt className="text-sm" />
                    </button>
                    
                    {/* Share Dropdown */}
                    <div className="absolute bottom-full right-0 mb-2 bg-white rounded-lg shadow-lg border border-gray-100 p-2 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-10">
                      <div className="space-y-1 min-w-[120px]">
                        <button
                          onClick={() => shareOffer(offer, 'whatsapp')}
                          className="w-full flex items-center gap-2 px-3 py-1.5 text-xs text-gray-700 hover:bg-green-50 rounded transition"
                        >
                          <FaWhatsapp className="text-green-500 text-sm" />
                          WhatsApp
                        </button>
                        <button
                          onClick={() => shareOffer(offer, 'telegram')}
                          className="w-full flex items-center gap-2 px-3 py-1.5 text-xs text-gray-700 hover:bg-blue-50 rounded transition"
                        >
                          <FaTelegram className="text-blue-500 text-sm" />
                          Telegram
                        </button>
                        <button
                          onClick={() => shareOffer(offer, 'email')}
                          className="w-full flex items-center gap-2 px-3 py-1.5 text-xs text-gray-700 hover:bg-gray-50 rounded transition"
                        >
                          <FaEnvelope className="text-gray-500 text-sm" />
                          Email
                        </button>
                        <button
                          onClick={() => shareOffer(offer, 'native')}
                          disabled={shareLoading === offer.id}
                          className="w-full flex items-center gap-2 px-3 py-1.5 text-xs text-gray-700 hover:bg-gray-50 rounded transition"
                        >
                          {shareLoading === offer.id ? (
                            <div className="w-3 h-3 border-2 border-gray-300 border-t-gray-600 rounded-full animate-spin"></div>
                          ) : (
                            <FaShareAlt className="text-gray-500 text-sm" />
                          )}
                          More
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Info Banner */}
        <div className="mt-8 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl p-4 border border-blue-100">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-blue-500 rounded-full flex items-center justify-center flex-shrink-0">
              <FaGift className="text-white text-sm" />
            </div>
            <div>
              <p className="text-xs font-bold text-gray-800">How to use offers?</p>
              <p className="text-[10px] text-gray-600">Copy the offer code and apply at checkout to get instant discounts and bonus coins!</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpecialOffers;